import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Job, JobCompanyInfo } from '@kanda-libs/ks-frontend-services';

import { URLS } from 'config';
import { selectors } from 'store';

export interface PayByBacsPropsHook {
  isLoading: boolean;
  job?: Job;
  jobCompanyInfo?: JobCompanyInfo;
}

export default function usePayByBacsProps(): PayByBacsPropsHook {
  const { push } = useHistory();

  const job = useSelector(selectors.job.getEntity);
  const jobCompanyInfo = useSelector(selectors.jobCompanyInfo.getEntity);

  const jobHasFetched = useSelector(selectors.job.getHasFetched);
  const infoHasFecthed = useSelector(selectors.jobCompanyInfo.getHasFetched);

  const isLoading = Boolean(!jobHasFetched || !infoHasFecthed);

  useEffect(() => {
    if (!job) return;
    const option = job?.customer_options?.checkout_option;
    const id = job?.id;
    if (!id) return;
    if (!option || option !== 'pay_by_bank') push(URLS.job.replace(':id?', id));
  }, [job, push]);

  return { isLoading, job, jobCompanyInfo };
}
